// 获取浏览器信息
export function getExplorerVersion() {
    var NV = {};
    var UA = navigator.userAgent.toLowerCase();
    console.log("UA:" + UA);
    try {
        NV.name = !-[1,] ? 'ie' :
            (UA.indexOf("firefox") > 0) ? 'firefox' :
                (UA.indexOf("chrome") > 0) ? 'chrome' :
                    window.opera ? 'opera' :
                        (UA.indexOf("safari") > 0) ? 'safari' :
                            'unkonw';
    } catch (e) { };
    try {
        NV.version = (NV.name == 'ie') ? UA.match(/msie ([\d.]+)/)[1] :
            (NV.name == 'firefox') ? UA.match(/firefox\/([\d.]+)/)[1] :
                (NV.name == 'chrome') ? UA.match(/chrome\/([\d.]+)/)[1] :
                    (NV.name == 'opera') ? UA.match(/opera.([\d.]+)/)[1] :
                        (NV.name == 'safari') ? UA.match(/safari\/([\d.]+)/)[1] :
                            '0';
    } catch (e) { };
    try {
        NV.shell = (UA.indexOf('360ee') > -1) ? '360Jisu' :
            (UA.indexOf('360se') > -1) ? '360Safe' :
                (UA.indexOf('se') > -1) ? 'Sogou' :
                    (UA.indexOf('aoyou') > -1) ? 'Aoyou' :
                        (UA.indexOf('theworld') > -1) ? 'Theworld' :
                            (UA.indexOf('worldchrome') > -1) ? 'TheworldChrome' :
                                (UA.indexOf('greenbrowser') > -1) ? 'Green' :
                                    (UA.indexOf('qq') > -1) ? 'QQ' :
                                        (UA.indexOf('baidu') > -1) ? 'Baidu' :
                                            (UA.indexOf('edg') > -1) ? 'Edge' :
                                                (UA.indexOf('firefox') > -1) ? 'Firefox' :
                                                    (UA.indexOf('opr') > -1) ? 'Opera' :
                                                        (UA.indexOf('chrome') > -1) ? 'Chrome' :
                                                            'Nnknown';
    } catch (e) { }
    // console.log('浏览器UA=' + UA +
    //     '\n\n浏览器名称=' + NV.name +
    //     '\n\n浏览器版本=' + NV.version +
    //     '\n\n浏览器外壳=' + NV.shell);
    return NV.name +' '+ NV.version;
}

//获取操作系统信息 
export function getMobileSystemInfo(){
    var sUserAgent = navigator.userAgent.toLowerCase();   
       
    var isWin = (navigator.platform == "Win32") || (navigator.platform == "Win64")|| (navigator.platform == "wow64");   
    
    var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");   
    if (isMac) {
        var identifier = 'Mac OS X (10([_|\.])[0|1|2|3|4|5|6|8|9|10|11]([0-9_\.]*))';
        var osRegExp = new RegExp(identifier.toLowerCase());
        var osRegExpResult = osRegExp.exec(sUserAgent);
        return `macOS ${osRegExpResult[1]}`
    }  
    var isUnix = (navigator.platform == "X11") && !isWin && !isMac;   
    if (isUnix) return "Unix ";   
    var isLinux = (String(navigator.platform).indexOf("Linux") > -1);   
    var bIsAndroid = sUserAgent.toLowerCase().match(/android/i) == "android";  
    if (isLinux) {  
    if(bIsAndroid) return "Android ";  
        else return "Linux ";   
    }  
    if (isWin) {   
        var is64 = sUserAgent.indexOf("win64") > -1||sUserAgent.indexOf("wow64") > -1;  
        var isDigits = ''
        if (is64) isDigits = "64"; 
        else isDigits = "32"; 
        var isWin2K = sUserAgent.indexOf("Windows nt 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;   
        if (isWin2K) return `Windows${isDigits} 2000`;   
        var isWinXP = sUserAgent.indexOf("Windows nt 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1  
        sUserAgent.indexOf("Windows XP") > -1;   
        if (isWinXP) return `Windows${isDigits} XP`;   
        var isWin2003 = sUserAgent.indexOf("Windows nt 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;   
        if (isWin2003) return `Windows${isDigits} 2003`;   
        var isWinVista= sUserAgent.indexOf("Windows nt 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;   
        if (isWinVista) return `Windows${isDigits} Vista`;   
        var isWin7 = sUserAgent.indexOf("Windows nt 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;   
        if (isWin7) return `Windows${isDigits} 7`;   
        var isWin8 = sUserAgent.indexOf("windows nt 6.2") > -1 || sUserAgent.indexOf("Windows 8") > -1;  
        if (isWin8) return `Windows${isDigits} 8`; 
        var isWin10 = sUserAgent.indexOf("windows nt 10.0")>-1||sUserAgent.indexOf("Windows 10")>-1;	
        if(isWin10)return `Windows${isDigits} 10`;				
    }  
    return "其他 ";
}

export default {
    getExplorerVersion,
    getMobileSystemInfo
}


// WEBPACK FOOTER //
// ./src/lib/systemCheck.js